import { render } from "./CommentsThread.vue?vue&type=template&id=6e361547&scoped=true"
import script from "./CommentsThread.vue?vue&type=script&lang=js"
export * from "./CommentsThread.vue?vue&type=script&lang=js"

import "./CommentsThread.vue?vue&type=style&index=0&id=6e361547&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e361547"]])

export default __exports__